<template>
	<div class="icon-trash">
		<svg
			width="17.500000"
			height="19.500000"
			viewBox="0 0 17.5 19.5"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			xmlns:xlink="http://www.w3.org/1999/xlink"
		>
			<desc>Created with Pixso.</desc>
			<defs />
			<path
				id="path (Border)"
				d="M13.5 3L16.75 3C17.17 3 17.5 3.33 17.5 3.75C17.5 4.16 17.17 4.5 16.75 4.5L0.75 4.5C0.33 4.5 0 4.16 0 3.75C0 3.33 0.33 3 0.75 3L4 3L4 2.75C4 2.37 4.07 2.02 4.21 1.67C4.35 1.35 4.55 1.05 4.8 0.8C5.05 0.55 5.35 0.35 5.67 0.21C6.02 0.07 6.37 0 6.75 0L10.75 0C11.12 0 11.47 0.07 11.82 0.21C12.14 0.35 12.44 0.55 12.69 0.8C12.94 1.05 13.14 1.35 13.28 1.67C13.42 2.02 13.5 2.37 13.5 2.75L13.5 3M12 3L12 2.75C12 2.58 11.96 2.41 11.9 2.26C11.83 2.11 11.74 1.98 11.63 1.86C11.51 1.75 11.38 1.66 11.23 1.59C11.08 1.53 10.91 1.5 10.75 1.5L6.75 1.5C6.58 1.5 6.41 1.53 6.26 1.59C6.11 1.66 5.98 1.75 5.86 1.86C5.75 1.98 5.66 2.11 5.59 2.26C5.53 2.41 5.5 2.58 5.5 2.75L5.5 3L12 3M2 15.75L2 6.75C2 6.33 2.33 6 2.75 6C3.16 6 3.5 6.33 3.5 6.75L3.5 15.75C3.5 16.05 3.55 16.34 3.67 16.62C3.79 16.89 3.95 17.13 4.15 17.34C4.36 17.54 4.6 17.7 4.87 17.82C5.15 17.94 5.44 18 5.75 18L11.75 18C12.05 18 12.34 17.94 12.62 17.82C12.89 17.7 13.13 17.54 13.34 17.34C13.54 17.13 13.7 16.89 13.82 16.62C13.94 16.34 14 16.05 14 15.75L14 6.75C14 6.33 14.33 6 14.75 6C15.17 6 15.5 6.33 15.5 6.75L15.5 15.75C15.5 16.25 15.4 16.74 15.2 17.2C15.01 17.65 14.74 18.05 14.4 18.4C14.05 18.74 13.65 19.01 13.2 19.2C12.74 19.4 12.25 19.5 11.75 19.5L5.75 19.5C5.24 19.5 4.75 19.4 4.29 19.2C3.84 19.01 3.44 18.74 3.09 18.4C2.75 18.05 2.48 17.65 2.29 17.2C2.09 16.74 2 16.25 2 15.75L2 15.75M6 14.75L6 7.75C6 7.33 6.33 7 6.75 7C7.16 7 7.5 7.33 7.5 7.75L7.5 14.75C7.5 15.16 7.16 15.5 6.75 15.5C6.33 15.5 6 15.16 6 14.75L6 14.75M10 14.75L10 7.75C10 7.33 10.33 7 10.75 7C11.17 7 11.5 7.33 11.5 7.75L11.5 14.75C11.5 15.16 11.17 15.5 10.75 15.5C10.33 15.5 10 15.16 10 14.75L10 14.75Z"
				:fill="color"
				fill-opacity="1.000000"
				fill-rule="evenodd"
			/>
		</svg>
	</div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

@Options({
	props: {
		color: { type: String, default: "#E83941" },
	},
})
export default class IconTrash extends Vue {}
</script>

<style scoped lang="scss">
.icon-trash {
	display: flex;
}
</style>
